import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllServiceObservations = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/service-observations',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveServiceObservation = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/service-observations',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateServiceObservation = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/service-observations/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteServiceObservation = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/service-observations/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllServiceObservations,
  saveServiceObservation,
  deleteServiceObservation,
  updateServiceObservation,
}
